exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.events .more {\n  width: 100%;\n  position: absolute;\n  transition: transform 0.4s;\n}\n.events .more .bullets {\n    position: absolute;\n    top: 1rem;\n    right: 0.75rem;\n}\n.events .more h4 > .ico-arrow-left {\n    font-size: 0.5rem;\n}\n.events .more .timeline .ico-calendar {\n    margin-top: 4px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-6f1187f4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calendar/EventMore.vue
// module id = 2689
// module chunks = 0